import * as angular from 'angular';

import { ComponentDefinition, EditSpotValueWithOptions } from '@models/index';

class SpotValueCellController implements angular.IComponentController {
    readonly decimals: number;
    readonly isEditMode: boolean;
    readonly name: string;
    readonly onChange: () => void;
    readonly spot: EditSpotValueWithOptions;

    static $inject = [];

    onValueChange() {
        if (this.onChange) {
            this.onChange();
        }
    }
}

export const wtSpotValueCell: ComponentDefinition = {
    componentId: 'wtSpotValueCell',
    controller: SpotValueCellController,
    template: require('./spotValueCell.component.html'),
    controllerAs: 'vm',
    bindings: {
        decimals: '<?',
        isEditMode: '<',
        name: '<',
        onChange: '&?',
        spot: '<'
    }
};